var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-top-wrap"},[_c('FooterTop')],1),_c('FooterMap',{on:{"trigger-lang":_vm.triggerLang}}),_c('FooterLetter'),_c('FooterBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }